export default __webpack_public_path__ + "static/media/ImgGift03.9772113f.jpg";